import { render, staticRenderFns } from "./monitorDetails.vue?vue&type=template&id=243fa688&scoped=true&"
import script from "./monitorDetails.vue?vue&type=script&lang=js&"
export * from "./monitorDetails.vue?vue&type=script&lang=js&"
import style0 from "./monitorDetails.vue?vue&type=style&index=0&id=243fa688&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243fa688",
  null
  
)

export default component.exports